import React, { useState, useEffect, useRef } from 'react'
import SALink from 'components/SALink'
import { CASE_STUDY_CAROUSEL_DATA } from '../../helpers/constants'
const delay = 3000

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  const [itemIndex, setItemIndex] = useState(0)
  const timeoutRef = useRef(null)

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }

  useEffect(() => {
    resetTimeout()
    timeoutRef.current = setTimeout(
      () =>
        setItemIndex((prevIndex) =>
          prevIndex === CASE_STUDY_CAROUSEL_DATA.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    )
    return () => {
      resetTimeout()
    }
  }, [itemIndex])
  return (
    <div data-section='case-study-carousel'>
      <div data-type='slideshow'>
        <div
          data-type='slider'
          style={{
            transform: `translate3d(${-itemIndex * 100}%, 0, 0)`,
          }}
        >
          {CASE_STUDY_CAROUSEL_DATA.map((image, index) => (
            <div data-type='slide' key={index} data-style={itemIndex === index ? 'active' : ''}>
              <picture data-type='image'>
                <img
                  width='692'
                  height='462'
                  itemProp='image'
                  className='lazyload'
                  data-src={image}
                  alt='case study'
                  role='presentation'
                  data-type='image'
                />
              </picture>
            </div>
          ))}
        </div>
      </div>
      <div data-type='text-section'>
        <p data-type='subtitle'>Inspiration,</p>
        <p data-type='subtitle'>Design Advice,</p>
        <p data-type='subtitle'>Case Studies & More</p>
        <SALink href='/trade-inspiration' data-type='explore-link'>
          Explore
        </SALink>
      </div>
    </div>
  )
}

export default Component